
import videoFile from '../Assets/video/1000060398.mp4';
function Loader() {
    const loaderStyle = {
        position: 'fixed',
        top: 0,
        left: 0,
        background: 'rgb(255, 255, 255)',
        height: '100%', 
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 9999,
    };

    const loaderVideoStyle = {
        maxWidth: '250px',
        maxHeight: '250px',
        backgroundColor: 'transparent',
        mixBlendMode: 'multiply',
    };

    return (
        <div style={loaderStyle}>
            <video 
                autoPlay 
                muted 
                loop 
                // playsInline  // Add this for mobile compatibility
                style={loaderVideoStyle}
            >
                <source 
                    src={videoFile} 
                    type="video/mp4" 
                    onError={(e) => console.error('Video error:', e)}
                />
                Your browser does not support the video tag.
            </video>
        </div>
    );
}

export default Loader;
